import React from 'react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { NetworkIcon, TwitterIcon, GithubIcon, LinkedinIcon, YoutubeIcon } from 'lucide-react';
const footerLinks = {
  product: [{
    label: 'Features',
    href: '#'
  }, {
    label: 'Pricing',
    href: '#'
  }, {
    label: 'Roadmap',
    href: '#'
  }, {
    label: 'Changelog',
    href: '#'
  }],
  resources: [{
    label: 'Documentation',
    href: '#'
  }, {
    label: 'API Reference',
    href: '#'
  }, {
    label: 'Community',
    href: '#'
  }, {
    label: 'Blog',
    href: '#'
  }],
  company: [{
    label: 'About',
    href: '#'
  }, {
    label: 'Careers',
    href: '#'
  }, {
    label: 'Contact',
    href: '#'
  }, {
    label: 'Press Kit',
    href: '#'
  }],
  legal: [{
    label: 'Privacy',
    href: '#'
  }, {
    label: 'Terms',
    href: '#'
  }, {
    label: 'Security',
    href: '#'
  }, {
    label: 'Cookies',
    href: '#'
  }]
};
const socialLinks = [{
  icon: <TwitterIcon className="w-5 h-5" />,
  href: '#',
  label: 'Twitter'
}, {
  icon: <GithubIcon className="w-5 h-5" />,
  href: '#',
  label: 'GitHub'
}, {
  icon: <LinkedinIcon className="w-5 h-5" />,
  href: '#',
  label: 'LinkedIn'
}, {
  icon: <YoutubeIcon className="w-5 h-5" />,
  href: '#',
  label: 'YouTube'
}];
export function Footer() {
  return <footer className="bg-surface-900 border-t border-surface-700">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-6 gap-12 mb-12">
          {/* Brand & Newsletter */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-primary-500 flex items-center justify-center">
                <NetworkIcon className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-white">StreamGraph</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Turn your entire job into an executable, self-documenting graph.
              Work smarter, not harder.
            </p>

            {/* Newsletter */}
            <div className="space-y-3">
              <p className="text-sm font-medium text-white">
                Subscribe to updates
              </p>
              <div className="flex gap-2">
                <Input placeholder="Enter your email" className="flex-1" />
                <Button>Subscribe</Button>
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-3">
              {footerLinks.product.map(link => <li key={link.label}>
                  <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map(link => <li key={link.label}>
                  <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map(link => <li key={link.label}>
                  <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map(link => <li key={link.label}>
                  <a href={link.href} className="text-sm text-gray-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-surface-700 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © 2024 StreamGraph, Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {socialLinks.map(social => <a key={social.label} href={social.href} aria-label={social.label} className="w-10 h-10 rounded-lg bg-surface-700 flex items-center justify-center text-gray-400 hover:text-white hover:bg-surface-600 transition-colors">
                {social.icon}
              </a>)}
          </div>
        </div>
      </div>
    </footer>;
}